import { apiCall, createQueryString } from "../imports";

const PREFIX = "notices/admin/notices";

export default {
  // لیست مناقصه/مزایده‌ها با فیلتر
  get(filters = {}) {
    return apiCall("get", `${PREFIX}${createQueryString(filters)}`);
  },

  // جزئیات یک مناقصه/مزایده
  show(id) {
    return apiCall("get", `${PREFIX}/${id}`);
  },

  // ایجاد
  create(data) {
    return apiCall("post", `${PREFIX}`, data);
  },

  // بروزرسانی
  update(id, data) {
    return apiCall("put", `${PREFIX}/${id}`, data);
  },

  // حذف
  delete(id) {
    return apiCall("delete", `${PREFIX}/${id}`);
  },

  // لیست پیشنهادهای یک مناقصه/مزایده
  bids(id, filters = {}) {
    return apiCall("get", `${PREFIX}/${id}/bids${createQueryString(filters)}`);
  },

  // لیست آیتم‌های پایان‌یافته
  closed(filters = {}) {
    return apiCall("get", `admin/closed-notices${createQueryString(filters)}`);
  },

  // دانلود فایل ضمیمه
  downloadAttachment(id) {
    return apiCall("get", `${PREFIX}/${id}/download`);
  },
};